import { render } from "./WalletModal.vue?vue&type=template&id=220a5c7e&scoped=true"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"

import "./WalletModal.vue?vue&type=style&index=0&id=220a5c7e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220a5c7e"]])

export default __exports__